import "angular-translate/dist/angular-translate.min.js";
import "angular-translate/dist/angular-translate-loader-url/angular-translate-loader-url.min.js";
import "angular-translate/dist/angular-translate-storage-cookie/angular-translate-storage-cookie.min.js";
import "angular-translate/dist/angular-translate-loader-static-files/angular-translate-loader-static-files.min.js";

export default 'pascalprecht.translate'